module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Birsfelden-357409a707fdb02fc6a71580171da720.svg";